import React from 'react';
import Reveal from './Reveal';
import './SectionHeader.css';

/**
 * SectionHeader — consistent eyebrow + heading + subheading block.
 *
 * Props:
 *  - eyebrow: small uppercase label
 *  - title: main heading (string or node)
 *  - subtitle: supporting copy
 *  - align: 'left' | 'center' (default 'left')
 */
const SectionHeader = ({ eyebrow, title, subtitle, align = 'left' }) => {
  return (
    <div className={`tra-section-header tra-section-header--${align}`}>
      {eyebrow && (
        <Reveal as="span" className="tra-eyebrow">
          {eyebrow}
        </Reveal>
      )}
      {title && (
        <Reveal as="h2" className="tra-heading" delay={0.05}>
          {title}
        </Reveal>
      )}
      {subtitle && (
        <Reveal as="p" className="tra-subheading" delay={0.1}>
          {subtitle}
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeader;
